import { defineComponent as _defineComponent } from 'vue'
type ButtonTypes = 'back' | 'cancel' | 'primary' | 'delete' | 'secondary';


export default /*#__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    action: null,
    disabled: { type: Boolean },
    type: null
  },
  setup(__props: any) {

const { action, disabled, type = 'primary' } = __props as { action: () => void; disabled?: boolean; type?: ButtonTypes }



const getButtonColor = (type?: ButtonTypes) => {
  switch (type) {
    case 'primary':
      return 'secondary';
    case 'delete':
      return 'error';
    case 'secondary':
      return 'gray';
    default:
      return undefined;
  }
};

const isTextButton = type === 'back' || type === 'cancel';
const isSlottedButton = !(type === 'back' || type === 'cancel');
const buttonColor = getButtonColor(type);

return { __sfc: true,getButtonColor, isTextButton, isSlottedButton, buttonColor }
}

})